<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 14H2V11.5C3 10 5 8.5 8 8.5C11 8.5 13 10 14 11.5V14Z"
      fill="#8E8F9F"
    />
    <circle
      cx="8"
      cy="4"
      r="3"
      fill="#8E8F9F"
    />
  </svg>
</template>

<script setup lang="ts"></script>
